"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingCustomerSalesOrders = void 0;
const React = require("react");
const react_1 = require("react");
const CustomerSalesOrdersContext_1 = require("../../contexts/CustomerSalesOrdersContext");
const Table_1 = require("../../../../../components/base/structure/Table");
const PendingCustomerSalesOrderStatus_1 = require("./PendingCustomerSalesOrderStatus");
const PendingCustomerSalesOrderCount_1 = require("./PendingCustomerSalesOrderCount");
const PendingCustomerSalesOrderDetails_1 = require("./PendingCustomerSalesOrderDetails");
const ViewPendingCustomerSalesOrderLink_1 = require("./ViewPendingCustomerSalesOrderLink");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PendingCustomerSalesOrders");
/**
 * Show a notification to highlight any pending orders, allowing it to be clicked through.
 */
const PendingCustomerSalesOrders = ({ className }) => {
    const { outstandingSalesOrders } = (0, react_1.useContext)(CustomerSalesOrdersContext_1.CustomerSalesOrdersContext);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const toggleVisibility = () => setIsExpanded(!isExpanded);
    const salesOrderCount = (0, react_1.useMemo)(() => Array.isArray(outstandingSalesOrders) ? outstandingSalesOrders.length : 0, [outstandingSalesOrders]);
    if (salesOrderCount === 0)
        return null;
    return (React.createElement("div", { className: css("", {
            "-isExpanded": isExpanded,
            className
        }) },
        React.createElement("div", { className: css("list") },
            React.createElement(Table_1.Table, null,
                React.createElement(Table_1.TableBody, null, outstandingSalesOrders.map(salesOrder => (React.createElement(Table_1.TableRow, { key: `pending-order-${salesOrder.salesOrderId}`, className: css("list_outstandingOrder") },
                    React.createElement(PendingCustomerSalesOrderStatus_1.PendingCustomerSalesOrderStatus, { salesOrder: salesOrder }),
                    React.createElement(PendingCustomerSalesOrderDetails_1.PendingCustomerSalesOrderDetails, { salesOrder: salesOrder }),
                    React.createElement(ViewPendingCustomerSalesOrderLink_1.ViewPendingCustomerSalesOrderLink, { salesOrderId: salesOrder.salesOrderId }))))))),
        React.createElement(PendingCustomerSalesOrderCount_1.PendingCustomerSalesOrderCount, { isExpanded: isExpanded, salesOrderCount: salesOrderCount, toggleVisibility: toggleVisibility })));
};
exports.PendingCustomerSalesOrders = PendingCustomerSalesOrders;
//# sourceMappingURL=index.js.map